import { NEUTRAL_100 } from "../../styles/colors"
import styled from "styled-components"

type TrashIconContainerProps = {
    $size?: number;
    $backgroundColor?: string;
    $borderColor?: string;
    $borderWidth?: number;
}

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconContainer = (styled.div<TrashIconContainerProps>`
    display: flex;
    align-items: center;
    justify-content: center;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
